@if (vm$ | async; as vm) {
  @if (vm.error) {
    <div class="m-0 py-2 alert alert-warning small" role="alert">
      {{ vm.error }}
    </div>
  } @else if (!vm.isLoading && vm.isVisible && vm.history) {
    <div class="row m-0">
      <div class="col-12 p-0">
        <p-timeline [value]="vm.history">
          <ng-template #marker let-event>
            <span style="min-width: 50px; font-size: 0.8rem" class="p-0 m-0 text-center small">
              <span
                class="py-0 px-2 m-0 rounded-pill lh-1 text-center bg-light border"
                [class.border-primary]="event.isCurrentVersion"
                [class.text-primary]="event.isCurrentVersion"
                [class.text-secondary]="!event.isCurrentVersion"
                style="font-weight: 600; font-size: 0.8rem">
                v{{ event.version }}
              </span>
            </span>
          </ng-template>
          <ng-template #content let-event>
            <div class="lh-1" [style.marginBottom.px]="vm.history.indexOf(event) === vm.history.length - 1 ? 0 : 32">
              {{ event.changeType }}
              @if (event.showStatus) {
                @switch (event.rentalAgreementStatus) {
                  @case (0) {
                    <span
                      class="badge rounded-pill bg-light border border-success text-success fw-bolder"
                      style="font-size: 11px"
                      >{{ event.statusDisplayName }}</span
                    >
                  }
                  @case (1) {
                    <span class="badge rounded-pill text-bg-success border border-success" style="font-size: 11px">{{
                      event.statusDisplayName
                    }}</span>
                  }
                  @default {
                    <span
                      class="badge rounded-pill bg-light border border-secondary text-secondary"
                      style="font-size: 11px"
                      >{{ event.statusDisplayName }}</span
                    >
                  }
                }
              }
              <div class="mt-2 text-muted super-small" [title]="event.changedDate">
                {{ event.changedBy }} • {{ event.changedDate | dateAgo: false }}
              </div>
              @if (!event.isCurrentVersion) {
                <button
                  type="button"
                  class="mt-2 btn btn-sm btn-outline-secondary"
                  (click)="navigateToRaWithVersion(event.version, event.isLatest)">
                  View this version
                </button>
              }
            </div>
          </ng-template>
        </p-timeline>
      </div>
    </div>
  } @else if (vm.isVisible) {
    <div class="m-0-auto">
      <app-loader />
    </div>
  }
}
